import React from 'react'
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import { Link } from 'react-router'
import i18next from 'i18next'
import validator from 'validator'

import LanguageSelectorFormControl from './LanguageSelectorFormControl'
import Error from './smart/ErrorContainer'
import GridContainer from './GridContainer'
import Button from './Button'

import adminStyles from './styles/admin.scss'

export default class AccountCreation extends React.Component {
  constructor(props) {
    super(props)

    // TODO: Move roles somewhere else.
    const availableRoles = ['member', 'admin']
    const defaultRole = availableRoles[0]

    this.state = {
      availableRoles: availableRoles,
      defaultRole: defaultRole,
      email: '',
      givenName: '',
      familyName: '',
      organisationId: props.isSuperAdminView ? '' : this.props.organisation.id,
      roles: [defaultRole],
      language: 'en',
      isValid: false
    }
  }

  render() {
    const { organisation, organisations, isSuperAdminView } = this.props

    return (
      <GridContainer>
        <div className={adminStyles.app}>
          <header>
            <h1>
              {i18next.t('new_account')} {!isSuperAdminView && <small>{organisation.name}</small>}
            </h1>
          </header>

          <div style={{ padding: '10px 40px 30px', border: '1px solid #E2E2E2' }}>
            <h2>{i18next.t('user_information')}</h2>

            <Row>
              <Col md={12}>
                {isSuperAdminView && (
                  <Row>
                    <Col md={6}>
                      <FormGroup controlId="organisation">
                        <ControlLabel>
                          {i18next.t('organisation')}{' '}
                          <Link to="/admin/organisations/new">{i18next.t('or_create_new')}</Link>
                        </ControlLabel>
                        <FormControl
                          name="organisationId"
                          componentClass="select"
                          onChange={this.onChange.bind(this)}
                          defaultValue=""
                        >
                          <option value="" />

                          {organisations.map(o => (
                            <option value={o.id} key={o.id}>
                              {o.name}
                            </option>
                          ))}
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col md={6}>
                    <FormGroup controlId="roles">
                      <ControlLabel>{i18next.t('privileges')}</ControlLabel>

                      {this.state.availableRoles.map((role, key) => (
                        <div key={key}>
                          <label style={{ fontWeight: 'normal' }}>
                            <input
                              ref={role}
                              type="checkbox"
                              name={role}
                              checked={this.state.roles.indexOf(role) !== -1}
                              onChange={this.onChangeRoles.bind(this)}
                              disabled={role === this.state.defaultRole}
                            />
                            &nbsp;{i18next.t(`role_${role}`)}{' '}
                            <small style={{ marginLeft: 10 }}>
                              {i18next.t(`role_${role}_description`)}
                            </small>
                          </label>
                        </div>
                      ))}
                    </FormGroup>
                  </Col>
                </Row>

                <br />

                <Row>
                  <Col md={6}>
                    <LanguageSelectorFormControl
                      label={i18next.t('ui_language')}
                      onChange={this.onChange.bind(this)}
                      defaultValue={this.state.language}
                      showOnlyAdminLanguages={true}
                      shouldTranslateLanguages={true}
                    />
                  </Col>
                </Row>

                <br />

                <Row>
                  <Col md={6}>
                    <FormGroup controlId="email">
                      <ControlLabel>{i18next.t('email')}</ControlLabel>
                      <FormControl
                        name="email"
                        type="email"
                        onChange={this.onChange.bind(this)}
                        value={this.state.email}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col sm={6}>
                    <FormGroup controlId="givenName">
                      <ControlLabel>{i18next.t('given_name')}</ControlLabel>
                      <FormControl
                        name="givenName"
                        type="text"
                        onChange={this.onChange.bind(this)}
                        value={this.state.givenName}
                      />
                    </FormGroup>
                  </Col>

                  <Col sm={6}>
                    <FormGroup controlId="familyName">
                      <ControlLabel>{i18next.t('family_name')}</ControlLabel>
                      <FormControl
                        name="familyName"
                        type="text"
                        onChange={this.onChange.bind(this)}
                        value={this.state.familyName}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <br />

          <Error />

          <div style={{ textAlign: 'center' }}>
            <Button
              text={i18next.t('send_activation_mail')}
              onClick={this.onAdd.bind(this)}
              disabled={!this.state.isValid}
            />
          </div>

          <br />
        </div>
      </GridContainer>
    )
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })

    this.validateState()
  }

  onChangeRoles(e) {
    this.setState({
      roles: this.state.availableRoles.filter(role => this.refs[role].checked)
    })

    this.validateState()
  }

  validateState() {
    const validate = () =>
      this.state.email != '' &&
      validator.isEmail(this.state.email) &&
      this.state.givenName != '' &&
      this.state.familyName != '' &&
      this.state.organisationId != '' &&
      this.state.roles != []

    this.setState({ isValid: validate() })
  }

  onAdd() {
    this.props.onAdd(
      this.state.email,
      this.state.givenName,
      this.state.familyName,
      this.state.organisationId,
      this.state.language,
      this.state.roles
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AccountCreation.js